import axios from 'axios';
import localStorage from '@/services/storage';
import Vue from 'vue';

const instance = axios.create({
    baseURL: process.env.VUE_APP_URL,
});

// Before each ajax request activate preloader screen
instance.interceptors.request.use((configAxios) => {
    configAxios.headers.common.Authorization = `Bearer ${localStorage.get('token', true)}`;

    return configAxios;
});

// After each ajax response deactivate preloader screen
// If response fail, again deactivate preloader screen too
instance.interceptors.response.use((configAxios) => {
    return configAxios;
}, (error) => {
    // Show user errors from backend
    let string = '';
    if (error.response.data.body.error_fields) {
        for (const property in error.response.data.body.error_fields) {
            string += error.response.data.body.error_fields[property].message + '<br>';
        }
        Vue.$toast.error(string);
    }
    return Promise.reject(error);
});

export default instance;
